import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    selectAllTags: (count: number) =>
      translate({ id: 'components.tagsList.button.selectAll', values: { count } }),
    deselectAllTags: (count: number) =>
      translate({ id: 'components.tagsList.button.deselectAll', values: { count } }),
    disabledTooltip: translate({ id: 'components.tagsList.disabledTag' }),
    placeholder: translate({ id: 'components.tagsList.search.placeholder' }),
    clearSearch: translate({ id: 'components.tagsList.button.clear' }),
    emptyTags: translate({ id: 'components.tagsList.suggestionsList.empty' }),

    listTitle: translate({ id: 'order.form.bulk.tags.partialList.heading' }),
    warningTooltip: (bannedTagCategory: 'tagsIn' | 'tagsOut') =>
      translate({
        id:
          bannedTagCategory === 'tagsIn'
            ? 'order.form.bulk.tags.warningTooltip.tagsIn'
            : 'order.form.bulk.tags.warningTooltip.tagsOut',
      }),
    addTooltip: translate({ id: 'order.form.bulk.tags.partial.addTooltip' }),
    removeTagTooltip: translate({ id: 'global.remove' }),
  }))

  return api
}
